import { FC } from 'react'
import { t } from 'translations'

const MeringoBar: FC = () => {
  return (
    <nav className="merinio-staff-navbar">
      <div className="text-center">{t('components.STAFF_WARNING')}</div>
    </nav>
  )
}

export default MeringoBar
